import { protoRoot, PARAMS, Request } from '../../../../protos'
import store from '../../../../store'
import axios from 'axios'
import { getUrl } from '..'

export const v1 = {
  async UpdateNotePermissions(params: protoRoot.note.UpdateNotePermissions.IRequest) {
    const { apiNames } = store.getState().api
    return await Request<protoRoot.note.UpdateNotePermissions.IResponse>(
      {
        method: 'POST',
        data: PARAMS<protoRoot.note.UpdateNotePermissions.IRequest>(
          params,
          protoRoot.note.UpdateNotePermissions.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.updateNotePermissions),
      },
      protoRoot.note.UpdateNotePermissions.Response
    )
  },
  async GetNotePermissions(params: protoRoot.note.GetNotePermissions.IRequest) {
    const { apiNames } = store.getState().api
    return await Request<protoRoot.note.GetNotePermissions.IResponse>(
      {
        method: 'GET',
        data: PARAMS<protoRoot.note.GetNotePermissions.IRequest>(
          params,
          protoRoot.note.GetNotePermissions.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.getNotePermissions),
      },
      protoRoot.note.GetNotePermissions.Response
    )
  },
  async AgreeAndDownloadNote(params: protoRoot.note.AgreeAndDownloadNote.IRequest) {
    const { apiNames } = store.getState().api
    return await Request<protoRoot.note.AgreeAndDownloadNote.IResponse>(
      {
        method: 'POST',
        data: PARAMS<protoRoot.note.AgreeAndDownloadNote.IRequest>(
          params,
          protoRoot.note.AgreeAndDownloadNote.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.agreeAndDownloadNote),
      },
      protoRoot.note.AgreeAndDownloadNote.Response
    )
  },
  async getInvitationCode(params: protoRoot.note.GetInvitationCode.IRequest) {
    const { apiNames } = store.getState().api
    return await Request<protoRoot.note.GetInvitationCode.IResponse>(
      {
        method: 'GET',
        data: PARAMS<protoRoot.note.GetInvitationCode.IRequest>(
          params,
          protoRoot.note.GetInvitationCode.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.getInvitationCode),
      },
      protoRoot.note.GetInvitationCode.Response
    )
  },
  async savePagePassword(params: protoRoot.note.SavePagePassword.IRequest) {
    const { apiNames } = store.getState().api
    return await Request<protoRoot.note.SavePagePassword.IResponse>(
      {
        method: 'POST',
        // config: requestConfig,
        data: PARAMS<protoRoot.note.SavePagePassword.IRequest>(
          params,
          protoRoot.note.SavePagePassword.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.savePagePassword),
      },
      protoRoot.note.SavePagePassword.Response
    )
  },
  async getPagePassword(params: protoRoot.note.GetPagePassword.IRequest) {
    const { apiNames } = store.getState().api
    return await Request<protoRoot.note.GetPagePassword.IResponse>(
      {
        method: 'GET',
        // config: requestConfig,
        data: PARAMS<protoRoot.note.GetPagePassword.IRequest>(
          params,
          protoRoot.note.GetPagePassword.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.getPagePassword),
      },
      protoRoot.note.GetPagePassword.Response
    )
  },
  async deletePagePassword(params: protoRoot.note.DeletePagePassword.IRequest) {
    const { apiNames } = store.getState().api
    return await Request<protoRoot.note.DeletePagePassword.IResponse>(
      {
        method: 'POST',
        // config: requestConfig,
        data: PARAMS<protoRoot.note.DeletePagePassword.IRequest>(
          params,
          protoRoot.note.DeletePagePassword.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.deletePagePassword),
      },
      protoRoot.note.DeletePagePassword.Response
    )
  },
  async syncToServer(params: protoRoot.sync.SyncToServer.IRequest) {
    const { apiNames } = store.getState().api
    return await Request<protoRoot.sync.SyncToServer.IResponse>(
      {
        method: 'POST',
        // config: requestConfig,
        data: PARAMS<protoRoot.sync.SyncToServer.IRequest>(
          params,
          protoRoot.sync.SyncToServer.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.syncToServer),
      },
      protoRoot.sync.SyncToServer.Response
    )
  },
  async getUrls(params: protoRoot.sync.GetUrls.IRequest) {
    const { apiNames } = store.getState().api
    return await Request<protoRoot.sync.GetUrls.IResponse>(
      {
        method: 'GET',
        // config: requestConfig,
        data: PARAMS<protoRoot.sync.GetUrls.IRequest>(
          params,
          protoRoot.sync.GetUrls.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.getUrls),
      },
      protoRoot.sync.GetUrls.Response
    )
  },
  async getFolderFiles(params: protoRoot.sync.GetFolderFiles.IRequest) {
    const { apiNames } = store.getState().api

    return await Request<protoRoot.sync.GetFolderFiles.IResponse>(
      {
        method: 'GET',
        // config: requestConfig,
        data: PARAMS<protoRoot.sync.GetFolderFiles.IRequest>(
          params,
          protoRoot.sync.GetFolderFiles.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.getFolderFiles),
      },
      protoRoot.sync.GetFolderFiles.Response
    )
  },
  async getNote(params: protoRoot.sync.GetFolderFiles.IRequest) {
    const { apiNames } = store.getState().api

    return await Request<protoRoot.sync.GetNote.IResponse>(
      {
        method: 'GET',
        // config: requestConfig,
        data: PARAMS<protoRoot.sync.GetNote.IRequest>(
          params,
          protoRoot.sync.GetNote.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.GetNote),
      },
      protoRoot.sync.GetNote.Response
    )
  },
  async getUploadToken(params: protoRoot.file.GetUploadToken.IRequest) {
    const { apiNames } = store.getState().api

    return await Request<protoRoot.file.GetUploadToken.IResponse>(
      {
        method: 'GET',
        // config: requestConfig,
        data: PARAMS<protoRoot.file.GetUploadToken.IRequest>(
          params,
          protoRoot.file.GetUploadToken.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.getUploadToken),
      },
      protoRoot.file.GetUploadToken.Response
    )
  },
  async getHistoricalVersionNoteUrls(params: protoRoot.sync.GetHistoricalVersionNoteUrls.IRequest) {
    const { apiNames } = store.getState().api

    return await Request<protoRoot.sync.GetHistoricalVersionNoteUrls.IResponse>(
      {
        method: 'GET',
        data: PARAMS<protoRoot.sync.GetHistoricalVersionNoteUrls.IRequest>(
          params,
          protoRoot.sync.GetHistoricalVersionNoteUrls.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.getHistoricalVersionNoteUrls),
      },
      protoRoot.sync.GetHistoricalVersionNoteUrls.Response
    )
  },
  async getHistoricalVersionNote(params: protoRoot.sync.GetHistoricalVersionNote.IRequest) {
    const { apiNames } = store.getState().api

    return await Request<protoRoot.sync.GetHistoricalVersionNote.IResponse>(
      {
        method: 'GET',
        data: PARAMS<protoRoot.sync.GetHistoricalVersionNote.IRequest>(
          params,
          protoRoot.sync.GetHistoricalVersionNote.Request
        ),
        url: getUrl(apiNames.v1.baseUrl, apiNames.v1.getHistoricalVersionNote),
      },
      protoRoot.sync.GetHistoricalVersionNote.Response
    )
  },
}
